import { createSlice } from "@reduxjs/toolkit";
// Types
import { PaymentNotice } from "../../@types/paymentNotice";
import { Account } from "../../@types/account";
// Actions
import findPaymentNotices from "./actions/findPaymentNotices";
import parsePaymentNoticesFile from "./actions/parsePaymentNoticesFile";

interface PaymentNoticesListState {
  paymentNotices: PaymentNotice[];
  findStatus: string;
  parseFileStatus: string;
  accountSelected?: Account;
}

const initialState = {
  paymentNotices: [],
  findStatus: "initial",
  parseFileStatus: "initial",
  accountSelected: undefined,
} as PaymentNoticesListState;

const paymentNoticesListSlice = createSlice({
  name: "paymentNoticesList",
  initialState,
  reducers: {
    setAccountSelected(state, action) {
      state.accountSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      /**
       * Find PaymentNotices
       */
      .addCase(findPaymentNotices.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findPaymentNotices.fulfilled, (state, { payload }) => {
        state.paymentNotices = [...payload];
        state.findStatus = "fulfilled";
      })
      .addCase(findPaymentNotices.rejected, (state) => {
        state.findStatus = "rejected";
      })
      /**
       * Import PaymentNotices from file
       */
      .addCase(parsePaymentNoticesFile.pending, (state) => {
        state.parseFileStatus = "pending";
      })
      .addCase(parsePaymentNoticesFile.fulfilled, (state) => {
        state.parseFileStatus = "fulfilled";
      })
      .addCase(parsePaymentNoticesFile.rejected, (state, { payload }) => {
        state.parseFileStatus = "rejected";
      });
  },
});

export const paymentNoticesList = paymentNoticesListSlice.reducer;
